var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 415 583.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b21e34;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.62,548.06,378.84,378.84a123.53,123.53,0,0,0,14.53-17.54c.33-.48.67-.95,1-1.43.44-.66.85-1.34,1.27-2,.72-1.13,1.44-2.25,2.11-3.39l.21-.36a122.88,122.88,0,0,0-19.11-149L209.62,35.91A122.79,122.79,0,0,0,36,209.56L75.5,249.1a23.89,23.89,0,0,0,33.78-33.78L69.74,175.78A75,75,0,1,1,175.84,69.69l100.6,100.6a122.2,122.2,0,0,0-71.25,34.89L36,374.41A122.79,122.79,0,1,0,209.62,548.06ZM69.74,514.29a75,75,0,0,1,0-106.1L239,239a75,75,0,1,1,0,106,23.89,23.89,0,1,0-33.78,33.78,122.23,122.23,0,0,0,71.26,34.89L175.84,514.29a75,75,0,0,1-106.1,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.7fc4c770bea4a3ef01c07420f46e70ad.svg";
export { ForwardRef as ReactComponent };